import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "d928ba22-4cd3-4d31-8971-aff59d117c37",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "732b3f30-e645-4ad5-850c-a3eb9ce5015b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "offer_icon_base",
      parent: "d928ba22-4cd3-4d31-8971-aff59d117c37",
      data: ""
    },
    {
      id: "a82bd6d7-8c5b-469c-9a3b-70b59518cd36",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "payer_react_offer_icon",
      parent: "d928ba22-4cd3-4d31-8971-aff59d117c37",
      data: ""
    },
    {
      id: "1e549520-6f01-459c-99c5-d03e4968768c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "offer_icon_timer",
      parent: "d928ba22-4cd3-4d31-8971-aff59d117c37",
      data: ""
    },
    {
      id: "e258f4fe-48d0-43c3-bcda-8cdcad45deee",
      type: "Text",
      name: "timeText",
      nameSpace: "",
      className: "",
      x: 19,
      y: 49,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "60:30:14",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: "bold",
        fontFamily: "FrancoisOne",
        fill: "#FFFFFF",
        stroke: "#000000",
        strokeThickness: 4,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 2
      },
      parent: "d928ba22-4cd3-4d31-8971-aff59d117c37",
      data: ""
    }
  ]
} as const;

export class PayerReactivationIconLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  timeText: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
